import React from 'react'
import { Control, Controller, UseControllerReturn } from 'react-hook-form'

import { Checkbox, FormControlLabel } from '@mui/material'

type Props = {
  control: Control
  id: string
  label: string
}

function CheckboxField({ control, id, label }: Props) {
  return (
    <FormControlLabel
      control={
        <Controller
          name={id}
          control={control}
          defaultValue={false}
          render={({ field: { ref, value, ...field } }: UseControllerReturn) => (
            <Checkbox {...field} inputRef={ref} checked={value} />
          )}
        />
      }
      label={label}
      sx={{ width: '48%' }}
    />
  )
}

export default CheckboxField
